import { render, staticRenderFns } from "./listModel.vue?vue&type=template&id=127bfdda&scoped=true&"
import script from "./listModel.vue?vue&type=script&lang=js&"
export * from "./listModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127bfdda",
  null
  
)

export default component.exports